// @flow

import React, { Component } from 'react'
import { max, extent } from 'd3-array'
import { scaleLinear, scaleTime } from 'd3-scale'
import { timeParse } from 'd3-time-format'
import { line as lineShape, curveMonotoneX } from 'd3-shape'
import { axisLeft, axisBottom } from 'd3-axis'

import Dots from './Dots'
import Grid from './Grid'
import Axis from './Axis'
import ToolTip from './ToolTip'

type Props = {
  k: string,
  title: string,
  graphData: Object,
}

type State = {
  width: number,
  height: number,
  tooltip: {
    display: boolean,
    pos: {
      x: number,
      y: number,
    },
    data: {
      key: string,
      value: string,
    },
  },
}

export default class LineChart extends Component<Props, State> {
  node: any

  state = {
    width: 800,
    height: 300,
    tooltip: {
      display: false,
      pos: { x: 0, y: 20 },
      data: { key: '', value: '' },
    },
  }

  showToolTip = ({ target }: Object) => {
    this.setState({
      tooltip: {
        display: true,
        data: {
          key: target.getAttribute('data-key'),
          value: target.getAttribute('data-value'),
        },
        pos: {
          x: target.getAttribute('cx'),
          y: target.getAttribute('cy'),
        },
      },
    })
  }

  hideToolTip = () => {
    this.setState({
      tooltip: {
        display: false,
        data: { key: '', value: '' },
        pos: { x: 0, y: 20 },
      },
    })
  }

  componentWillMount() {
    window.addEventListener('resize', this.updateSize)
  }

  componentDidMount() {
    this.updateSize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize)
  }

  updateSize = () =>
    this.setState({ width: this.node.getBoundingClientRect().width })

  render() {
    const LineStyle = {
      fill: 'none',
      stroke: '#0871a5',
      strokeWidth: '3px',
    }

    let { graphData, k, title } = this.props

    const margin = { top: 50, right: 50, bottom: 20, left: 50 },
      w = this.state.width - (margin.left + margin.right),
      h = this.state.height - (margin.top + margin.bottom)

    const parseDate = timeParse('%Y-%m-%d')

    const data = graphData.map(d => {
      const spliTedDate = d.day.slice(0, 10)
      const date = parseDate(spliTedDate)
      return { ...d, date }
    })

    const dataRange = [data[0], data[data.length - 1]]

    const x = scaleTime()
      .domain(extent(dataRange, d => d.date))
      .rangeRound([0, w])

    const y = scaleLinear()
      .domain([0, max(data, d => parseInt(d[k], 10))])
      .range([h, 0])

    const yAxis = axisLeft()
      .scale(y)
      .ticks(5)

    const xAxis = axisBottom()
      .scale(x)
      .tickValues(dataRange.map(d => d.date))
      .ticks(2)

    const yGrid = axisLeft()
      .scale(y)
      .ticks(10)
      .tickSize(-w, 0, -1)
      .tickFormat('')

    const line = lineShape()
      .curve(curveMonotoneX)
      .x(d => x(d.date))
      .y(d => y(d[k]))

    const transform = `translate(${margin.left},${margin.top})`

    return (
      <div ref={node => (this.node = node)}>
        <svg
          style={{ overflow: 'visible' }}
          width={this.state.width}
          height={this.state.height}
        >
          <g transform={transform}>
            <Grid h={h} grid={yGrid} gridType="y" />
            <Axis h={h} axis={yAxis} axisType="y" />
            <Axis h={h} axis={xAxis} axisType="x" />
            <path style={LineStyle} d={line(data)} strokeLinecap="round" />
            <Dots
              data={data}
              k={k}
              x={x}
              y={y}
              showToolTip={this.showToolTip}
              hideToolTip={this.hideToolTip}
            />
            <ToolTip title={title} tooltip={this.state.tooltip} />
          </g>
        </svg>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/LineChart.js